'use strict';
import React from 'react';
import * as T from 'prop-types';
import {I18nComponent} from '../../core-utilities/react-i18n/I18nComponent';


export const I18nMessage = I18nComponent(({label}) => label, [
  {prop: 'label', dynamic: props => ({code: props.message})},
]);

I18nMessage.propTypes = {
  message: T.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/I18nMessage/I18nMessage.js